import { fieldsRef } from "./firebaseconn";

export async function getFields() {
  try {
    const fields = await fieldsRef.get();
    return fields.data();
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
